import type {SVGProps} from 'react'
const ChevronRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M692.69,500.01L342.67,150l-35.36,35.36,314.66,314.65-314.64,314.64,35.35,35.35,350-349.99h.01Z" />
  </svg>
)
export {ChevronRightIcon}
